module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/banshoen-3b6b2b175619f716415e53badc6c8c26.jpg";